<template>
    <div>
        <div @click.stop="open" @mousedown="move" id="downloadTask">
            <Icon type="md-download"></Icon>
        </div>
        <Modal width="1000" title="任务列表" footer-hide v-model="openForm">
            <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
                :height="400">
                <template slot-scope="{ row, index }" slot="action">

                    <Button size="small">获取</Button>
                </template>
            </Table>
        </Modal>
    </div>

</template>
<script>

export default {
    data() {
        return {
            openForm: false,
            columns: [{
                title: '文件名',
                key: 'a'

            }, {
                title: '文件格式',
                key: 'a'

            }, {
                title: '文件大小',
                key: 'a'

            }, {
                title: '生成进度',
                key: 'a'

            }, {
                title: '文件名',
                slot: 'action'

            }],
            tableData: []
        };
    },
    methods: {
        move(e) {
            let odiv = document.getElementById("downloadTask");
            let disX = e.clientX - odiv.offsetLeft;
            let disY = e.clientY - odiv.offsetTop;
            document.onmousemove = (e) => {
                let left = e.clientX - disX;
                let top = e.clientY - disY;
                this.positionX = top;
                this.positionY = left;
                odiv.style.left = left + "px";
                odiv.style.top = top + "px";
            };
            var that = this;
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
                that.openForm = true;
            };
        },
        open() {
            this.openForm = true;
        }
    },

};
</script>
<style>
#downloadTask {
    width: 30px;
    height: 30px;
    background: red;
    border-radius: 50%;
    position: fixed;
    right: 20px;
    top: 60px;
    cursor: move;
    color: #fff;
    line-height: 30px;
    text-align: center;
    z-index: 22;
}

#downloadTask i {
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/downloadTask.vue